module.exports = __webpack_public_path__ + "img/trophyseries.6e06be8c.png";